/* eslint-disable @typescript-eslint/no-deprecated */
export type { InfoLabelProps, InfoLabelSlots, InfoLabelState } from './components/InfoLabel/index';
export {
  InfoLabel,
  infoLabelClassNames,
  renderInfoLabel_unstable,
  useInfoLabelStyles_unstable,
  useInfoLabel_unstable,
} from './components/InfoLabel/index';
